import { Countries } from "@/constants";

export default function normalizeAddressRegion(
  country?: string | null,
  state?: string | null,
  international?: string | null
) {
  if (!country) {
    return { state: state || "", international: international || "" };
  }

  return country === Countries.USA
    ? { state: state || "", international: "" }
    : { state: "", international: international || "" };
}
